import { FullscreenModal } from "@/components/modals/FullscreenModal";
import type { ReactNode, RefObject } from "react";

interface ItemModalProps {
  open: boolean;
  children: ReactNode;
  contentRef?: RefObject<HTMLDivElement>;
  onClose?: () => void;
  onSwipeClose?: () => void;
}

/** Full-screen item details; children unmount as soon as it starts closing. */
export function ItemModal(props: ItemModalProps) {
  return <FullscreenModal {...props} title="Detalhes do item" />;
}
